import { render } from "./LoginChooser.vue?vue&type=template&id=022a8cbb&scoped=true"
import script from "./LoginChooser.vue?vue&type=script&lang=js"
export * from "./LoginChooser.vue?vue&type=script&lang=js"

import "./LoginChooser.vue?vue&type=style&index=0&id=022a8cbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022a8cbb"]])

export default __exports__